import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";
import { lazy } from "react";

const Home = lazy(() => import("./main/index.jsx"));

export const homeRoutes = {
  children: [
    {
      path: "/",
      element: <Home />,
      errorElement: <ErrorBoundary />
    }
  ]
};
